module.exports = __webpack_public_path__ + "static/media/testimonial (1).0b2d72d6.png";